import React, { useState, useEffect, useRef } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import { notRepeatingShuffle } from '../utils/SmartLabelUtils'
import 'katex/dist/katex.min.css'
import { RectangleContent } from '../UIUtilsFiles/RectangleContent'

function MatchingExercise(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    handleSuccessChange,
    timerEnd,
    isVerifyMode,
    showCountTime,
    screenMode,
    canvasAreaDimensions,
    isBgAudioPlayed
  } = props
  const {
    ControlID,
    QuestionType,
    AnswerType,
    Options,
    Score,
    Background,
    AnswerColorFill,
    QuestionColorFill,
    Description,
    AnswerFontSize,
    QuestionFontSize,
    AnswerFillColor,
    QuestionFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Opacity,
    FontStyle,
    Italic,
    Bold
  } = mcData

  const [selectedArrayCoordinate, setSelectedArrayCoordinate] = useState([])
  const [leftArray, setLeftArray] = useState([])
  const [rightArray, setRightArray] = useState([])

  const [selectedLeftOption, setSelectedLeftOption] = useState()
  const [selectedLeftIndex, setSelectedLeftIndex] = useState(-1)
  const [lineCoords, setlineCoords] = useState()
  const [letfIndex, setletfIndex] = useState(-1)
  const [tempLine, settempLine] = useState()
  const [correctAnswerArray, setCorrectAnswerArray] = useState([])
  const [selectedAnswerArray, setSelectedAnswerArray] = useState([])
  const [valueAttempt, setValueAttempt] = useState(0)
  const [currentScore, setCurrentScore] = useState(0)
  const [correctAnswerCoordArray, setCorrectAnswerCoordArray] = useState([])
  const [counter, setCounter] = useState(0)
  const [coordinates, setCoordinates] = useState([])

  useEffect(() => {
    let leftArrayValues = []
    let rightArrayValues = []
    let correctAnswerArrayCopy = []
    let correctAnswerArrayCoordCopy = []

    for (let i = 0; i < Options.length; i++) {
      correctAnswerArrayCopy[i] = {
        left: Options[i].OptionLeft,
        right: Options[i].OptionRight
      }
      correctAnswerArrayCoordCopy[i] = {
        left: Options[i].OptionLeft,
        right: Options[i].OptionRight,
        leftCoord: {},
        rightCoord: {}
      }
    }
    setCorrectAnswerArray(correctAnswerArrayCopy)
    setCorrectAnswerCoordArray(correctAnswerArrayCoordCopy)

    //Initialize left array and right array
    for (let i = 0; i < Options.length; i++) {
      leftArrayValues.push(Options[i].OptionLeft)
      rightArrayValues.push(Options[i].OptionRight)
    }
    let shuffledRightArray = notRepeatingShuffle(rightArrayValues)
    setRightArray(shuffledRightArray)
    setLeftArray(leftArrayValues)
  }, [])

  useEffect(() => {
    let selectedValueArray = []
    let selectedCoordinateArray = []
    if (defaultValue) {
      const { selectedArray } = defaultValue.CtlValue
      setSelectedAnswerArray(selectedArray)
      let defaultScore = defaultValue.CtlScore
      setCurrentScore(defaultScore)
    } else {
      for (let i = 0; i < Options.length; i++) {
        selectedValueArray.push(undefined)
        selectedCoordinateArray.push(undefined)
      }
      setSelectedArrayCoordinate(selectedCoordinateArray)
      setSelectedAnswerArray([])
    }
  }, [defaultValue])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, currentScore)
    }
  }, [timerEnd])

  useEffect(() => {
    console.log('counter', counter)
    if (counter) {
      let correctAnswerArrayCoordCopy = correctAnswerCoordArray
      for (let index = 0; index < Options.length; index++) {
        correctAnswerArrayCoordCopy[index].leftCoord = document
          .getElementById(index + 'left')
          .getBoundingClientRect()
      }

      correctAnswerArrayCoordCopy.map((firstValue, firstIndex) => {
        rightArray.map((secValue, secIndex) => {
          if (firstValue.right.OptionValue === secValue.OptionValue) {
            correctAnswerArrayCoordCopy[firstIndex].rightCoord = document
              .getElementById(secIndex + 'right')
              .getBoundingClientRect()
          }
        })
      })

      setCorrectAnswerCoordArray(correctAnswerArrayCoordCopy)
      let coordinatesCopy = []
      for (let index = 0; index < correctAnswerArrayCoordCopy.length; index++) {
        let x1 =
          correctAnswerArrayCoordCopy[index].leftCoord.x +
          correctAnswerArrayCoordCopy[index].leftCoord.width
        let x2 = correctAnswerArrayCoordCopy[index].rightCoord.x
        let y1 =
          correctAnswerArrayCoordCopy[index].leftCoord.y +
          correctAnswerArrayCoordCopy[index].leftCoord.height / 2
        let y2 =
          correctAnswerArrayCoordCopy[index].rightCoord.y +
          correctAnswerArrayCoordCopy[index].rightCoord.height / 2
        coordinatesCopy.push({ x1: x1, x2: x2, y1: y1, y2: y2 })
      }
      setCoordinates(coordinatesCopy)

      //Set coordinates for selected array
      let selectedCoordinateArrayCop = []

      if (defaultValue) {
        selectedAnswerArray.forEach((selected, index) => {
          if (selected) {
            const { OptionLeft, OptionRight } = selected
            const leftValue = correctAnswerArrayCoordCopy.find(
              (d) => d.left.OptionValue === OptionLeft.OptionValue
            )
            const rev = [...correctAnswerArrayCoordCopy].reverse()
            const rightValue = rev.find(
              (d) => d.right.OptionValue === OptionRight.OptionValue
            )

            selectedCoordinateArrayCop[index] = {
              leftCoord: leftValue.leftCoord,
              rightCoord: rightValue.rightCoord
            }
          }
        })
        let coordinatesCopyValu = []
        for (
          let index = 0;
          index < selectedCoordinateArrayCop.length;
          index++
        ) {
          let x0 =
            ((selectedCoordinateArrayCop[index].leftCoord.x +
              selectedCoordinateArrayCop[index].leftCoord.width) /
              canvasAreaDimensions.width) *
            100
          let y0 =
            ((selectedCoordinateArrayCop[index].leftCoord.y +
              selectedCoordinateArrayCop[index].leftCoord.height / 2) /
              canvasAreaDimensions.height) *
            100
          let x1 =
            (selectedCoordinateArrayCop[index].rightCoord.x /
              canvasAreaDimensions.width) *
            100
          let y1 =
            ((selectedCoordinateArrayCop[index].rightCoord.y +
              selectedCoordinateArrayCop[index].rightCoord.height / 2) /
              canvasAreaDimensions.height) *
            100
          coordinatesCopyValu.push({ x0: x0, x1: x1, y0: y0, y1: y1 })
        }
        setSelectedArrayCoordinate(coordinatesCopyValu)
      }
    }
  }, [counter])

  useEffect(() => {
    if (explanationClick) {
      if (Score === currentScore) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }, [explanationClick])

  useEffect(() => {
    if (valueAttempt > 0) {
      let score = 0
      for (let index = 0; index < correctAnswerArray.length; index++) {
        if (selectedAnswerArray[index]) {
          if (
            correctAnswerArray[index].right.OptionValue ===
            selectedAnswerArray[index].OptionRight.OptionValue
          ) {
            let scoreCopy = Score / correctAnswerArray.length
            score = score + scoreCopy
            handleSuccessChange(true)
          } else {
            handleSuccessChange(false)
          }
        }
      }
      setCurrentScore(score)
      onAttemptChange(1)
      validateCorrectAnswer(false, score)
    }
  }, [valueAttempt])

  function validateCorrectAnswer(timerValue, score) {
    let ctlValueCopy = {
      selectedArray: selectedAnswerArray
    }
    onValueChange(ControlID, ctlValueCopy, score, Score, '', timerValue)
  }

  function handleLeftClick(selectedAnswer, selectedIndex, coordinatesValue) {
    setSelectedLeftOption(selectedAnswer)
    setlineCoords({
      x: coordinatesValue.x + coordinatesValue.width,
      y: coordinatesValue.y + coordinatesValue.height / 2
    })
    settempLine({
      x0: coordinatesValue.x + coordinatesValue.width,
      y0: coordinatesValue.y + coordinatesValue.height / 2
    })
    setletfIndex(selectedIndex)
    setSelectedLeftIndex(selectedIndex)
  }

  function handleRightClick(selectedAnswer, selectedIndex, coordinatesValue) {
    if (letfIndex >= 0) {
      let selectedArrayCoordinateCopy = [...selectedArrayCoordinate]

      selectedArrayCoordinateCopy[letfIndex] = {
        x0: (lineCoords.x / canvasAreaDimensions.width) * 100,
        y0: (lineCoords.y / canvasAreaDimensions.height) * 100,
        x1: (coordinatesValue.x / canvasAreaDimensions.width) * 100,
        y1:
          ((coordinatesValue.y + coordinatesValue.height / 2) /
            canvasAreaDimensions.height) *
          100
      }

      let selectedAnswerArrayCopy = selectedAnswerArray
      selectedAnswerArrayCopy[selectedLeftIndex] = {
        OptionLeft: selectedLeftOption,
        OptionRight: selectedAnswer
      }
      setSelectedAnswerArray(selectedAnswerArrayCopy)
      setletfIndex(-1)
      settempLine(undefined)
      setSelectedArrayCoordinate(selectedArrayCoordinateCopy)
      setValueAttempt((valueAttempt) => valueAttempt + 1)
    }
  }

  return (
    <div className='slide-comp-wrapper'>
      <div
        style={{
          alignContent: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          width: '100%'
        }}
        onLoad={(e) => {
          setCounter((counter) => counter + 1)
        }}
      >
        <div style={{ zIndex: 1 }}>
          {leftArray.map((item, index) => (
            <div
              className='card-shadow matchLeftItem'
              id={index + 'left'}
              key={index.toString()}
              onClick={(e) =>
                handleLeftClick(
                  item,
                  index,
                  e.currentTarget.getBoundingClientRect()
                )
              }
              onMouseDown={(e) =>
                handleLeftClick(
                  item,
                  index,
                  e.currentTarget.getBoundingClientRect()
                )
              }
              style={{
                background: QuestionFillColor,
                fontSize:
                  QuestionFontSize === 'SMALL'
                    ? SMALL_DESKTOP
                    : QuestionFontSize === 'LARGE'
                    ? LARGE_DESKTOP
                    : MEDIUM_DESKTOP,
                color: QuestionColorFill,
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: '#B5B5B5'
                // borderColor:
                //   isPractice || completed === 1 || !isActive
                //     ? selectedAnswerArray[index]
                //       ? correctAnswerArray[index].right.OptionValue ===
                //         selectedAnswerArray[index].OptionRight.OptionValue
                //         ? '#3EC986'
                //         : '#FF551F'
                //       : '#B5B5B5'
                //     : SelectionColor
              }}
            >
              <RectangleContent
                contentType={QuestionType}
                contentData={item.OptionValue}
                index={index}
              />

              <img
                src='https://picsum.photos/200/300'
                style={{
                  alignSelf: 'center',
                  position: 'absolute',
                  opacity: 0.01,
                  width: '1px',
                  height: '1px'
                }}
              />
            </div>
          ))}
        </div>
        {isVerifyMode &&
          coordinates &&
          coordinates.map((coords, index) => {
            if (coords) {
              const { x1, y1, x2, y2 } = coords
              return (
                <svg
                  key={index.toString()}
                  style={{
                    position: 'absolute',
                    height: '100vh',
                    width: '100vw',
                    marginTop: '-20vh'
                  }}
                >
                  <line
                    x1={x1}
                    y1={y1}
                    x2={x2}
                    y2={y2}
                    stroke='#0bff31'
                    strokeWidth='3'
                  />
                </svg>
              )
            }
          })}
        {!isVerifyMode &&
          selectedArrayCoordinate.map((coords, index) => {
            if (coords) {
              const { x0, y0, x1, y1 } = coords
              return (
                <svg
                  key={index.toString()}
                  style={{
                    position: 'absolute',
                    height: '85%',
                    width: '100%',
                    display: 'flex',
                    alignSelf: 'flex-end',
                    marginBottom:
                      index === 0
                        ? '7%'
                        : index === 1
                        ? '6%'
                        : index === 2
                        ? '5%'
                        : '4%'
                  }}
                >
                  <line
                    x1={x0.toString().concat('%')}
                    y1={y0.toString().concat('%')}
                    x2={x1.toString().concat('%')}
                    y2={y1.toString().concat('%')}
                    stroke={
                      isPractice || completed === 1 || !isActive
                        ? correctAnswerArray[index].right.OptionValue ===
                          selectedAnswerArray[index].OptionRight.OptionValue
                          ? '#3EC986'
                          : '#FF551F'
                        : SelectionColor
                    }
                    strokeWidth='3'
                  />
                </svg>
              )
            }
          })}
        {tempLine && (
          <svg
            style={{
              position: 'absolute',
              height: '100vh',
              width: '100vw',
              marginTop: screenMode === 'phone' ? '-35%' : '-12%',
              zIndex: 0
            }}
          >
            <line
              x1={tempLine.x0}
              y1={tempLine.y0}
              x2={tempLine.x1 ? tempLine.x1 : tempLine.x0}
              y2={tempLine.y1 ? tempLine.y1 : tempLine.y0}
              stroke='#FFC42D'
              strokeWidth='3'
            />
          </svg>
        )}
        <div
          style={{ width: '20%', zIndex: 1 }}
          onMouseMove={(e) => {
            if (letfIndex >= 0) {
              settempLine({
                ...tempLine,
                x1: e.nativeEvent.x,
                y1: e.nativeEvent.y
              })
            }
          }}
        />
        <div style={{ zIndex: 1 }}>
          {rightArray.map((item, index) => (
            <div
              className='card-shadow matchRightItem'
              id={index + 'right'}
              key={index.toString()}
              onClick={(e) =>
                handleRightClick(
                  item,
                  index,
                  e.currentTarget.getBoundingClientRect()
                )
              }
              onMouseUp={(e) =>
                handleRightClick(
                  item,
                  index,
                  e.currentTarget.getBoundingClientRect()
                )
              }
              style={{
                background: AnswerFillColor,

                fontSize:
                  AnswerFontSize === 'SMALL'
                    ? SMALL_DESKTOP
                    : AnswerFontSize === 'LARGE'
                    ? LARGE_DESKTOP
                    : MEDIUM_DESKTOP,
                color: AnswerColorFill,
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: '#B5B5B5'
                // borderColor:
                //   isPractice || completed === 1 || !isActive
                //     ? selectedAnswerArray[index]
                //       ? correctAnswerArray[index].right.OptionValue ===
                //         selectedAnswerArray[index].OptionRight.OptionValue
                //         ? '#3EC986'
                //         : '#FF551F'
                //       : '#B5B5B5'
                //     : SelectionColor
              }}
            >
              <RectangleContent
                contentType={AnswerType}
                contentData={item.OptionValue}
              />
              <img
                src='https://picsum.photos/200/300'
                style={{
                  alignSelf: 'center',
                  position: 'absolute',
                  opacity: 0.01,
                  width: '1px',
                  height: '1px'
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MatchingExercise
